import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { alterFullpage } from '~/data/actions/siteActions'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Hint from '~/Common-Objects/UI/Hint/Hint'
import Icons from '~/Common-Objects/UI/Icons/index'
import NewUserForm from '~/Common-Objects/NewUserForm/newUserForm.jsx'

const AccountApprovalRequired = ({
    approvedAction,
    inReviewAction,
    messageOrientation = 'left',
    notApprovedText,
    inReviewText,
    activateFrom
}) => {
    const account = useSelector((state) => state.accountMaster)
    const dispatch = useDispatch()

    const isNotApproved =
        (account.accountMaster.deny || !account.accountMaster.approved) && !account.accountMaster.doneNewUserQuestions

    const isInReview =
        (account.accountMaster.deny || !account.accountMaster.approved) && account.accountMaster.doneNewUserQuestions

    const activateAccount = () => {
        dispatch(
            alterFullpage(
                <NewUserForm
                    from={activateFrom}
                    finish={() => {
                        dispatch(alterFullpage(undefined))
                    }}
                />
            )
        )
    }

    if (isNotApproved) {
        return (
            <div
                style={{
                    display: 'flex',
                    gap: '16px',
                    alignItems: 'center',
                    flexDirection: messageOrientation === 'left' ? 'row' : 'row-reverse'
                }}
            >
                <Hint style={{ margin: '0', backgroundColor: '#FAE3A7' }}>
                    <Icons
                        className='mar-r5'
                        icon={'warning'}
                        style={{ width: 20, height: 20 }}
                        color='#e2ab1e'
                    />
                    {notApprovedText}
                </Hint>
                <Button
                    className='button-primary'
                    iconLeft={<Icons icon='shieldtick' />}
                    onClick={activateAccount}
                >
                    Request Approval
                </Button>
            </div>
        )
    }

    if (isInReview) {
        return (
            <div
                style={{
                    display: 'flex',
                    gap: '16px',
                    alignItems: 'center',
                    flexDirection: messageOrientation === 'left' ? 'row' : 'row-reverse'
                }}
            >
                <Hint style={{ margin: '0', backgroundColor: '#FAE3A7' }}>
                    <Icons
                        className='mar-r5'
                        icon={'warning'}
                        style={{ width: 20, height: 20 }}
                        color='#e2ab1e'
                    />
                    {inReviewText}
                </Hint>
                <div style={{ pointerEvents: 'none', opacity: 0.5 }}>
                    {inReviewAction ? inReviewAction : approvedAction}
                </div>
            </div>
        )
    }

    return approvedAction
}

export default AccountApprovalRequired
